// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import qs from 'qs'
import VueLazyLoad from 'vue-lazyload'
import '@/assets/common/common.css'
import '@/assets/common/vc.css'
import '../static/font/iconfont.css'
import api from '@/request/index'
import axios from '@/request/http'
import global from '@/constants/Global.constants'
import progressive from 'progressive-image/dist/vue';

Vue.config.productionTip = false
Vue.use(ElementUI, {
    locale
})

Vue.prototype.global = global
Vue.prototype.$api = api
Vue.prototype.qs = qs
Vue.prototype.$axios = axios

router.beforeEach((to, from, next) => {
    new Promise((resolve, reject) => {
        if (!global.DATA_DICT.resource_prefix) {
            api.base.getDataDict({
                asp: 10,
                type: 'base_file_upload'
            }).then(res => { // 初始化数据字典
                if (res.data.code === '0000') {
                    for (let i = 0; i < res.data.data.infoList.length; i++) {
                        let item = res.data.data.infoList[i]
                        global.DATA_DICT[item.infoCode] = item.infoValue
                    }
                }
                resolve()
            })
        } else {
            resolve()
        }
    }).then(() => {
        /* 路由发生变化修改页面title */
        if (to.meta.title) {
            document.title = to.meta.title
        }
        if (store.state.token) {
            store.dispatch('setToken', store.state.token)
        }
        if (store.state.user) {
            store.dispatch('updateUserInfo', store.state.user)
        }
        if (to.path === '/login' || to.path === '/registerRetail') {
            next()
        } else if (to.path.indexOf('cart') > 0 || to.path.indexOf('member') > 0) {
            if (!store.state.token) {
                Vue.prototype.$message({
                    message: '身份已过期，请重新登录'
                })
                store.dispatch('setToken', '')
                store.dispatch('updateUserInfo', '')
                store.dispatch('clearCartCount')
                next({
                    path: '/login'
                })
            } else {
                next()
            }
        } else {
            next()
        }
    })
})
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})
Vue.use(progressive, {
    removePreview: true,
    scale: true
})
Vue.use(VueLazyLoad, {
    error: './static/img/loaing.gif', //报错需要的图片
    // require('./static/img/loading.gif')
    loading: './static/img/loading.png' // 替换需要的图片
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    beforeCreate() {
        Vue.prototype.$bus = this
    },
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js